<template>
    <div v-if="showBlock" class="p-20 bg-white">
        <WebInquiryForm :id="`dataTrackingInquiryInlineForm-${props.content.webInquiryName}`"
                        class="max-w-600 mx-auto"
                        :content="computedContent"/>
    </div>
</template>

<script setup lang="ts">
import { PropType, computed } from 'vue';
import tokenService from '@/core/auth/token.service';
import { WebInquiryBlockViewModel } from '@/types/contentServerContract';
import WebInquiryForm, { WebInquiryFormContent } from '@/project/app/blocks/webinquiries/WebInquiryForm.vue';

const props = defineProps({
    content: {
        type: Object as PropType<WebInquiryBlockViewModel>,
        required: true
    }
});
const computedContent = computed((): WebInquiryFormContent => {
    return {
        ...props.content,
        heading: props.content.header || '',
        bodyText: props.content.subheader || '',
        commentInputHeader: props.content.commentInputHeader || '',
        commentInputPlaceholderText: props.content.commentInputPlaceholderText || '',
        contactConfirmationText: props.content.contactConfirmationText || '',
        ctaText: props.content.ctaText || '',
        ctaColor: props.content.ctaColor || '',
        showCommentInput: props.content.allowComment,
        successHeading: props.content.receiptHeader || '',
        successBodyText: props.content.receiptBodyText || '',

        webInquiryOption: {
            webInquiryName: props.content.webInquiryName || '',
            businessLines: props.content.businessLines || [],
            isPrivateLabel: props.content.privateLabel,
            brand: props.content.brand || '',
        }
    }
});

const userCustomerCategorization = computed((): string => {
    const userData = tokenService.getUserData(false);
    return userData?.salesCategory || '';
});

const showBlock = computed((): boolean => {
    return (props.content.customerCategorization || []).includes(userCustomerCategorization.value);
});

</script>
